class TrailService {
    hasGeolocationData(trail) {
        return trail.gpx !== undefined
            || trail.kml !== undefined
            || trail.geojson !== undefined;
    }

    downloadGeolocationData(trail) {
        let url = null;

        if (trail.gpx) {
            url = trail.gpx;
        } else if (trail.geojson) {
            url = trail.geojson;
        } else if (trail.kml) {
            url = trail.kml;
        }

        if (url) {
            window.open(url);
        }
    }
}

export default new TrailService();



// WEBPACK FOOTER //
// src/services/trail.js